import { isProd } from "@/config/common";
import {
  ContentfulLocaleEnum,
  CountryCodeEnum,
  CountryNameEnum,
  CurrencyCodeEnum,
  DomainEnum,
  ElevateCodeEnum,
  LanguageCodeEnum,
  type Market,
  PSPEnum,
  SiteLocaleEnum,
  SiteNameEnum,
} from "./i18n-config";

export const pt: Market = {
  psp: PSPEnum.ADYEN,
  flag: "🇵🇹",
  currency: CurrencyCodeEnum.EUR,
  countryCode: CountryCodeEnum.PT,
  countryName: CountryNameEnum.PT,
  languageCode: LanguageCodeEnum.EN,
  locale: `${LanguageCodeEnum.EN}-${CountryCodeEnum.PT}`,
  upperCaseLocale: `${LanguageCodeEnum.EN}-${CountryCodeEnum.PT.toUpperCase()}`,
  contentfulLocale: ContentfulLocaleEnum.EU,
  siteLocale: SiteLocaleEnum.PT,
  elevateMarket: ElevateCodeEnum.EU,
  externalStoreId: "ecom-noga",
  searchPathName: "/search",
  domain: DomainEnum.NOGA,
  imageCdn: isProd()
    ? "https://cdn.no-ga.com"
    : "https://media.stage.cdn-norce.tech/1413",
  siteName: SiteNameEnum.EU,
};
